import React, { useState, useCallback } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { FileCopy as CopyIcon, Check as CheckIcon } from '@material-ui/icons';

const CopyButton = ({ text, tooltip = "Copy to clipboard" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }, [text]);

  return (
    <Tooltip title={copied ? "Copied!" : tooltip} arrow>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          handleCopy();
        }}
        size="small"
        aria-label={copied ? "Copied!" : tooltip}
        className="copy-button-icon"
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;

